$(function()
{
	$(el("mainContainer")).on("click","#btnSafebikeOptions", function(){

		getSafebikeOptions();

		return false;
	});

	$(el("mainContainer")).on("keypress", "#edtValue", function(e) {
		const charCode = e.which ? e.which : e.keyCode;
		if (charCode < 48 || charCode > 57) {
			e.preventDefault();
		}
	});
});

function getSafebikeOptions ()
{
	var oFrm = $(el("safebikeInsuranceForm"));
	var bValid = validateForm(oFrm);

	if(bValid)
	{
		$(el("insuranceOptions")).html('<div class="loader"><i class="fa fa-spinner fa-spin"></i></div>');

		var sParams = getValues(oFrm);
		var oCall   = callAjax("getSafebikeOptions", sParams, "post","/index.cfm/insurance/ajax/getSafebikeOptions");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType === "")
			{
				$(el("insuranceOptions")).html(oData.html).show();
			}
			else
			{
				$(el("insuranceOptions")).html("");
				showAlert("error", oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}